import React from 'react'
import { PageHeaderProps } from './PageHeader.interface'
import styles from './PageHeader.module.scss'

const PageHeader: React.FC<PageHeaderProps> = ({
  heading,
  subheading,
  className,
  headingClasses,
  subHeadingClasses,
}) => {
  const baseHeadingClasses = `text-[24px] lg:text-[42px] ${styles.header}`
  const baseSubHeadingClasses = `font-gt-haptik text-[18px] lg:text-[20px] mt-[20px] opacity-75 ${styles.subheader}`

  return (
    <div className={`${styles.pageHeaderWrapper} ${className || ''}`}>
      <h1 className={`${baseHeadingClasses} ${headingClasses || ''}`}>{heading}</h1>

      {subheading && (
        <h2 className={`${baseSubHeadingClasses} ${subHeadingClasses || ''}`}>{subheading}</h2>
      )}
    </div>
  )
}

export default PageHeader
